// extracted by mini-css-extract-plugin
export default {"subHeader":"SubHeader_subHeader__XDz87","backContainer":"SubHeader_backContainer__jVjIH","backButton":"SubHeader_backButton__sO+vc"};